import commonMixin from './../mixins/_common';
import flashMessageMixin from '../mixins/_flash_messages';
import multiImageUploader from './_multi_image_uploader';

import draggable from 'vuedraggable';
import _ from 'lodash';

/**
 * 繰り返し設定用コンポーネント
 */
export default {
    name: 'Loop',
    template: '#loop_component_template',
    data() {
        return {
            // 変更前のmain(配列はwatchで変更前データを取得できない為)
            old_main: [],
        };
    },
    props: {
        // slotで使える変数(モーダル内で編集するデータ)
        modelValue: {
            type: Array,
            default: () => ([]),
            required: false
        },
        // 新規追加ボタンから追加する時のデータ
        add_data: {
            type: Object,
            default: () => ({}),
            required: false
        },
        // データ追加される位置
        add_data_potision: {
            type: String, // prepend|append
            default: 'prepend',
            required: false
        },
        // 追加最大数
        limit: {
            type: Number,
            default: null,
            required: false
        },
        // D&D禁止フラグ
        no_drag: {
            type: Boolean,
            default: false,
            required: false
        },
        // ソート禁止フラグ
        no_sort: {
            type: Boolean,
            default: false,
            required: false
        },
        // 枠追加禁止フラグ
        no_add: {
            type: Boolean,
            default: false,
            required: false
        },
        // 一括画像追加禁止フラグ
        no_bulk_image_add: {
            type: Boolean,
            default: true,
            required: false
        },
        // 保存する画像の接頭語
        edit_id_dir: {
            type: [String, Number],
            required: false,
            default: null
        },
        // 画像の保存先(一括画像追加禁止フラグが「false」の場合に指定する)
        page_dir: {
            type: String,
            required: false,
            default: 'common',
        },
        // 独自クラスを追記する
        add_class: {
            type: String,
            default: '',
            required: false
        },
        // 削除ボタン非表示数
        del_btn_hidden: {
            type: Number,
            default: 0,
            required: false
        }
    },
    components: {
        'multi-image-uploader': multiImageUploader,
        draggable,
    },
    computed: {
        main: {
            // 編集中のデータ
            get() {
                return (this.modelValue ?? []).map((data, index) => ({ id: this.createKey(data, index), data }));
            },
            set(value) {
                this.emitUpdatValue(value.map(data => data?.data ?? data));
            },
        },
        // 先頭追加か否か
        isPrepend: function () {
            return (this.add_data_potision === 'prepend');
        }
    },
    watch: {
        // 登録最大数を超えたらアラート、値を元に戻す
        main: {
            handler: function (value) {
                if (this.limit !== null && this.limit < value.length) {
                    this.main = _.cloneDeep(this.old_main);
                    swal(this.limit + 'つ以上は登録できません');
                } else {
                    this.old_main = _.cloneDeep(value);
                }
            },
            deep: true
        }
    },
    mixins: [commonMixin, flashMessageMixin],
    emits: ['update:modelValue', 'input'],
    methods: {
        // 最初か
        isFirst: function (index) {
            return (index === 0);
        },
        // 最後か
        isLast: function (index) {
            return (this.main.length === index + 1);
        },
        // 追加
        add: function (data) {
            if (this.isPrepend) {
                this.addLead(data);
            } else {
                this.addTail(data);
            }
        },
        // 先頭追加
        addLead: function (data) {
            if (typeof data === 'undefined') {
                data = _.cloneDeep(this.add_data);
            }
            this.modelValue.unshift(data);
        },
        // 後方追加
        addTail: function (data) {
            if (typeof data === 'undefined') {
                data = _.cloneDeep(this.add_data);
            }
            this.modelValue.push(data);
        },
        // コピー
        copy: function (index) {
            let data = _.cloneDeep(this.modelValue[index]);
            // コピーしたパーツの下部に追加
            this.modelValue.splice(index + 1, 0, data);
        },
        // 差し替え
        replace: function (index, data) {
            this.modelValue[index] = data;
        },
        // 削除
        remove: function (index) {
            this.modelValue.splice(index, 1);
        },
        // 全て削除
        removeAll: function () {
            this.main = [];
        },
        // 前へ
        prev: function (index) {
            if (!this.isFirst(index)) {
                this.main = this.$_moveAt(this.main, index, index - 1);
            }
        },
        // 最上部へ
        toTop: function (index) {
            if (!this.isFirst(index)) {
                this.main = this.$_moveAt(this.main, index, 0);
            }
        },
        // 次へ
        next: function (index) {
            if (!this.isLast(index)) {
                this.main = this.$_moveAt(this.main, index, index + 1);
            }
        },
        // 最下部へ
        toBottom: function (index) {
            if (!this.isLast(index)) {
                this.main = this.$_moveAt(this.main, index, this.main.length - 1);
            }
        },
        // 並び替え用でキーを生成
        createKey: function (data, index) {
            return JSON.stringify(data) + index + moment().unix() + Math.random();
        },
        // D&Dコールバック
        onMoved: function () {
            this.emitInput(this.modelValue);
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function (value) {
            this.$emit('update:modelValue', value);
        },
        // D&Dコールバック用
        emitInput: function (value) {
            this.$emit('input', value);
        }
    }
};
